<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12 ">
                <div class="card">
                    <Toolbar>
                        <template #left>
                        </template>
                    </Toolbar>
                </div>
            </div>
            <div class="p-col-12">
                <div class="card">
                    <Link v-if="oprpengadaan" href="/organisasi_pengadaan/create" class="p-inputgroup-addon "><Button label="Tambah Organisasi Pengadaan" icon="pi pi-plus" /></Link>
                    <DataTable ref="dt" :value="datatable.data" :lazy="true" data-key="id" :paginator="true" :rows="10" :loading="datatable.loading" :total-records="datatable.totalRecords" filter-display="menu" :global-filter-fields="datatable.globalFilterFields" v-model:filters="datatable.filters" paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rows-per-page-options="[5, 10, 25]" current-page-report-template="Menampilkan data ke {first} sampai {last} dari total {totalRecords} data" @page="onPage($event)" @sort="onSort($event)" @filter="onFilter()">
                        <template #header>
                            <div class="table-header">
                                <h5 class="p-m-0 text-center">
                                    Daftar Organisasi Pengadaan
                                </h5>
                                <div class="flex justify-content-between">
                                    <Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button-outlined" @click="clearFilter()" />
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="datatable.filters['global'].value" @input="onFilter()" @keydown.enter="onFilter()" placeholder="Keyword Search" />
                                    </span>
                                </div>
                            </div>
                        </template>
                        <Column field="nama_paket_pengadaan" header="Nama Paket" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.nama_paket_pengadaan }}
                            </template>
                        </Column>
                        <Column field="nama_ppk" header="PPK" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.nama_ppk }}
                            </template>
                        </Column>
                        <Column field="status" header="Status" :sortable="true">
                            <template #body="slotProps">
                                <Badge v-if="slotProps.data.verifikasi" severity="warning">
                                    {{ slotProps.data.status }}
                                </Badge>
                                <Badge v-if="slotProps.data.belum" severity="danger">
                                    {{ slotProps.data.status }}
                                </Badge>
                                <Badge v-if="slotProps.data.selesai" severity="success">
                                    {{ slotProps.data.status }}
                                </Badge>
                            </template>
                        </Column>
                        <Column header="Aksi" style="width: 200px;">
                            <template #body="slotProps">
                                <div class="flex gap-1 m-1">
                                    <Button 
                                        icon="pi pi-eye"
                                        class="p-button-info p-button-sm"
                                        @click="show(slotProps.data.id)"
                                        v-tooltip="'Lihat Detail'"
                                    />
                                    <Button 
                                        icon="pi pi-pencil"
                                        class="p-button-warning p-button-sm"
                                        @click="edit(slotProps.data.id)"
                                        v-if="slotProps.data.can.update"
                                        v-tooltip="'Edit'"
                                    />
                                    <div v-if="oprpengadaan">
                                        <Button v-if="slotProps.data.can.delete" icon="pi pi-trash" class="p-button-sm p-button-danger"
                                            @click="showDeleteDialog(slotProps.data.id)" v-tooltip="'Hapus'" />
                                    </div>
                                </div>
                                <div v-if="verifikatorpa">
                                    <Button 
                                        class="p-button-info p-button-sm mr-1"
                                        @click="verifikasipa(slotProps.data.id)"
                                        v-if="slotProps.data.can.verifikasipa" >
                                        Verifikasi
                                    </Button>
                                </div>
                                <div v-if="adminkpbj">
                                    <Button 
                                        class="p-button-warning p-button-sm mr-1"
                                        @click="pokja(slotProps.data.id)"
                                        v-if="slotProps.data.can.pokja" >
                                        + POKJA
                                    </Button>
                                </div>
                                <div v-if="kakpbj">
                                    <Button 
                                        class="p-button-info p-button-sm mr-1"
                                        @click="verifikasikakpbj(slotProps.data.id)"
                                        v-if="slotProps.data.can.verifikasikakpbj" >
                                        Verifikasi
                                    </Button>
                                </div>
                            </template>
                        </Column>
                        <template #empty>
                            Belum ada Data!
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>

        <DeleteDialog ref="deleteDialog" v-model:visible="deleteDialog" :loading="deletingModel" @delete="onDelete" />
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Chip from 'primevue/chip';
import Badge from 'primevue/badge';
import DeleteDialog from "../../Components/DeleteDialog";
import Toolbar from "primevue/toolbar";
import { Link } from '@inertiajs/inertia-vue3'

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        Toolbar,
        Link,
        InputText,
        Chip,
        Badge
    },
    props : {
        oprpengadaan : Boolean,
        verifikatorpa : Boolean,
        adminkpbj : Boolean,
        kakpbj : Boolean,
    },
    data() {
        return {
            datatable: {
                loading: true,
                totalRecords: 0,
                data: null,
                filters: {
                    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                    // 'status': { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                globalFilterFields: ['nama_paket_pengadaan', 'nama_ppk', 'status'],
                lazyParams: {}
            },
            menuItems: [
                {
                    label: 'Tambah Organisasi Pengadaan',
                    icon: 'pi pi-fw pi-plus',
                    class: 'p-button-primary p-button-raised',
                    command: () => {
                        this.$inertia.get(this.route('organisasi_pengadaan.create'));
                    },
                },
            ],
            importDialog: false,
            importForm: this.$inertia.form({
                file: null
            }),
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
            isAuthorized: false,
        }
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
    },
    mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: 'id',
            sortOrder: -1,
            filters: this.datatable.filters,
            globalFilterFields: this.datatable.globalFilterFields
        };
        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.datatable.loading = true;
            this.datatableService.getData(this.route('organisasi_pengadaan.datatable'), {
                dt_params: JSON.stringify(this.datatable.lazyParams),
                searchable_columns: JSON.stringify(this.datatable.globalFilterFields)
            }).then(data => {
                this.datatable.data = data.payload.data;
                this.datatable.totalRecords = data.payload.total;
                this.datatable.loading = false;
            }).catch(error => {
                console.error('Error loading data:', error);
                this.datatable.data = [];
                this.datatable.totalRecords = 0;
                this.datatable.loading = false;
            });
        },
        onFilter() {
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.datatable.lazyParams.first = 0; // Reset to first page when filtering
            this.loadLazyData();
        },
        clearFilter() {
            this.datatable.filters = {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                // 'status': {value: null, matchMode: FilterMatchMode.EQUALS},
            };
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.datatable.lazyParams.first = 0; // Reset to first page when clearing filter
            this.loadLazyData();
        },
        onPage(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // console.log(this.datatable.lazyParams);
            // this.loadLazyData();
        },
        onSort(event) {
            // console.log(event);
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // this.loadLazyData();
        },
        create(id) {
            this.$inertia.visit(this.route('organisasi_pengadaan.create', id), { preserveScroll: true });
        },
        verifikasipa(id) {
            this.$inertia.visit(this.route('organisasi_pengadaan.verifikasipa', id), { preserveScroll: true });
        },
        verifikasikakpbj(id) {
            this.$inertia.visit(this.route('organisasi_pengadaan.verifikasi_kakpbj', id), { preserveScroll: true });
        },
        pokja(id) {
            this.$inertia.visit(this.route('organisasi_pengadaan.tambah_pokja', id), { preserveScroll: true });
        },
        show(id) {
            this.$inertia.visit(this.route('organisasi_pengadaan.show', id), { preserveScroll: true });
        },
        edit(id) {
            this.$inertia.visit(this.route('organisasi_pengadaan.edit', id), { preserveScroll: true });
        },
        showDeleteDialog(model) {
            this.selectedModel = model;
            this.deleteDialog = true;
        },
        onDelete() {
            this.deletingModel = true;
            this.$inertia.delete(this.route('organisasi_pengadaan.destroy', this.selectedModel), {
                onSuccess: () => {
                    this.deletingModel = false;
                    this.deleteDialog = false;
                    this.loadLazyData();
                    this.$refs.deleteDialog.onClose();
                }
            })
        },
    }
}
</script>

<style scoped></style>
